import { render } from "./ProfileFusoTab.vue?vue&type=template&id=c964e434&scoped=true&ts=true"
import script from "./ProfileFusoTab.vue?vue&type=script&lang=ts"
export * from "./ProfileFusoTab.vue?vue&type=script&lang=ts"

import "./ProfileFusoTab.vue?vue&type=style&index=0&id=c964e434&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c964e434"]])

export default __exports__